import Component from '../classes/Component'
// import Swiper from 'swiper'
// import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import map from 'lodash/map'
import { app } from '../utils/store'
import gsap from 'gsap'

export default class Slider extends Component {
    constructor({ element }) {
        super({ element: element })

        window.addEventListener('load', () => {
            if (this.element.getAttribute('data-slider') == 'compositions' && this.element.hasAttribute('multiple-rows')) {
                this.createSliderCompositionsMultipleRows()
            } else if(this.element.getAttribute('data-slider') == 'compositions') {
                this.createSliderCompositions()
            }
        })
    }

    createSliderCompositions = () => {
        this.wrapper = this.element.querySelector('.carousel--wrapper')
        this.count = this.wrapper.getAttribute('data-counter')

        if (!app.device.mobile && (this.count > 4)) {
            const { left, width } = this.wrapper.getBoundingClientRect()

            let slide = (window.innerWidth * .25)

            let maximum = this.wrapper.clientWidth
            let offset = maximum + (slide * (this.count - 4))

            this.wrapper.style.setProperty('width', `${(offset)}px`)
            this.wrapper.style.setProperty('max-width', 'unset')
            this.wrapper.style.setProperty('min-width', `${maximum}px`)

            this.timeline = gsap.timeline({ paused: true })
            this.timeline.to(this.wrapper, {
                x: -(offset - maximum),
                ease: 'none',
            })

            this.wrapper.addEventListener("mousemove", (event) => {
                const halfWidth = width / 2;
                const mouseX = event.x - left;
                // const x = gsap.utils.interpolate(-halfWidth, halfWidth, mouseX / width)

                let timelineUpdate = gsap.quickTo(this.timeline, 'progress', {
                    duration: .4,
                    progress: gsap.utils.interpolate(0, 1, progress),
                    overwrite: true,
                })

                let progress = gsap.utils.mapRange((window.innerWidth / 2), (maximum - (slide / 3)), 0, 1, mouseX)

                if (mouseX > (window.innerWidth / 2) && mouseX < maximum) {
                    timelineUpdate(progress)
                }
            })

            this.wrapper.addEventListener("mouseleave", (event) => {
                gsap.to(this.wrapper, {
                    x: 0,
                    ease: 'expo.inOut',
                })
            })
        }
    }

    createSliderCompositionsMultipleRows = () => {
        this.wrappers = this.element.querySelectorAll('.carousel--wrapper')
        
        map(this.wrappers, (wrapper) => {
            this.count = wrapper.getAttribute('data-counter')

            if (!app.device.mobile && (this.count > 4)) {
                const { left, width } = wrapper.getBoundingClientRect()

                let slide = (window.innerWidth * .25)

                let maximum = wrapper.clientWidth
                let offset = maximum + (slide * (this.count - 4))

                wrapper.style.setProperty('width', `${(offset)}px`)
                wrapper.style.setProperty('max-width', 'unset')
                wrapper.style.setProperty('min-width', `${maximum}px`)

                this.timeline = gsap.timeline({ paused: true })
                this.timeline.to(this.wrapper, {
                    x: -(offset - maximum),
                    ease: 'none',
                })

                wrapper.addEventListener("mousemove", (event) => {
                    const halfWidth = width / 2;
                    const mouseX = event.x - left;
                    // const x = gsap.utils.interpolate(-halfWidth, halfWidth, mouseX / width)

                    let timelineUpdate = gsap.quickTo(this.timeline, 'progress', {
                        duration: .4,
                        progress: gsap.utils.interpolate(0, 1, progress),
                        overwrite: true,
                    })

                    let progress = gsap.utils.mapRange((window.innerWidth / 2), (maximum - (slide / 3)), 0, 1, mouseX)

                    if (mouseX > (window.innerWidth / 2) && mouseX < maximum) {
                        timelineUpdate(progress)
                    }
                })

                wrapper.addEventListener("mouseleave", (event) => {
                    gsap.to(this.wrapper, {
                        x: 0,
                        ease: 'expo.inOut',
                    })
                })
            }
        })
    }
}